module.exports = {
    RECEIVE_ALL_QUALITY: 'RECEIVE_ALL_QUALITY',
}
